var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Array.from(Array(_vm.element.number).keys())),function(tick,idx){return _c('div',{staticStyle:{"height":"200px"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }